module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('h4', [_vm._v("Loading Data...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-8"
  }, [_c('crmFollowUpDetailsDialog', {
    ref: "openDialog",
    attrs: {
      "showNewButton": true
    }
  }), _vm._v(" "), _c('Dropdown', {
    staticStyle: {
      "width": "200px",
      "margin": "-3.5% 70%",
      "float": "right"
    },
    attrs: {
      "options": _vm.stageFilterOptions,
      "optionLabel": "name",
      "placeholder": "Filter by Stage"
    },
    scopedSlots: _vm._u([{
      key: "value",
      fn: function(slotProps) {
        return [(slotProps.value) ? _c('div', {
          style: ({
            backgroundColor: slotProps.value.color,
            color: _vm.getTextColor(slotProps.value.color),
            padding: '2px 8px',
            borderRadius: '3px'
          })
        }, [_vm._v("\n              " + _vm._s(slotProps.value.name) + "\n            ")]) : _c('span', [_vm._v("\n              " + _vm._s(slotProps.placeholder) + "\n            ")])]
      }
    }, {
      key: "option",
      fn: function(slotProps) {
        return [_c('div', {
          style: ({
            backgroundColor: slotProps.option.color,
            color: _vm.getTextColor(slotProps.option.color),
            padding: '5px 10px'
          })
        }, [_vm._v("\n              " + _vm._s(slotProps.option.name) + "\n            ")])]
      }
    }]),
    model: {
      value: (_vm.selectedStage),
      callback: function($$v) {
        _vm.selectedStage = $$v
      },
      expression: "selectedStage"
    }
  })], 1), _vm._v(" "), _c('DataTable', {
    ref: "po",
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.filteredCrmFollowUpLists,
      "paginator": true,
      "rows": 100,
      "rowsPerPageOptions": [100, 500, 1000],
      "filters": _vm.filters,
      "rowClass": _vm.rowClass,
      "editMode": "cell",
      "selection": _vm.selectedProduct1,
      "selectionMode": "single"
    },
    on: {
      "update:selection": function($event) {
        _vm.selectedProduct1 = $event
      }
    },
    scopedSlots: _vm._u([(this.$store.getters.modules.includes('5.38')) ? {
      key: "header",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('Button', {
          attrs: {
            "icon": "pi pi-external-link",
            "label": "Export"
          },
          on: {
            "click": function($event) {
              return _vm.exportCSV($event)
            }
          }
        })], 1)]
      },
      proxy: true
    } : null], null, true)
  }, [_vm._v(" "), _c('Column', {
    attrs: {
      "header": "S.n"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n        " + _vm._s(slotProps.index + 1) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Client Name",
      "field": "clientName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['clientName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'clientName', $$v)
            },
            expression: "filters['clientName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Contact Person",
      "field": "contactPerson",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['contactPerson']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'contactPerson', $$v)
            },
            expression: "filters['contactPerson']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Address",
      "field": "address",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['address']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'address', $$v)
            },
            expression: "filters['address']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Contact Number",
      "field": "contactNumber",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n        " + _vm._s(_vm.formatContactNumber(slotProps.data.contactNumber)) + "\n      ")]
      }
    }, {
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['contactNumber']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'contactNumber', $$v)
            },
            expression: "filters['contactNumber']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Remarks-Product-Rate",
      "field": "remarks",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-eye"
          },
          on: {
            "click": function($event) {
              return _vm.openRemarks(slotProps.data)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Update Stage",
      "headerStyle": "width: 8em"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('Dropdown', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "options": _vm.stageOptions,
            "optionLabel": "name",
            "optionValue": "value",
            "placeholder": "Select Stage"
          },
          on: {
            "change": function($event) {
              return _vm.updateStage(slotProps.data)
            }
          },
          model: {
            value: (slotProps.data.stage),
            callback: function($$v) {
              _vm.$set(slotProps.data, "stage", $$v)
            },
            expression: "slotProps.data.stage"
          }
        })]
      }
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                " + _vm._s(_vm.getPayStatusLabel(slotProps.data.stage)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Email",
      "field": "gmail",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['gmail']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'gmail', $$v)
            },
            expression: "filters['gmail']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Customer Type",
      "field": "customerType",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['customerType']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'customerType', $$v)
            },
            expression: "filters['customerType']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Priority",
      "field": "priority",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['priority']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'priority', $$v)
            },
            expression: "filters['priority']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Stage",
      "field": "stage",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['stage']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'stage', $$v)
            },
            expression: "filters['stage']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Sample Sent",
      "field": "sampleQuotationSent",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['sampleQuotationSent']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'sampleQuotationSent', $$v)
            },
            expression: "filters['sampleQuotationSent']"
          }
        })]
      },
      proxy: true
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n  " + _vm._s(slotProps.data.sampleQuotationSent ? 'Yes' : 'No') + "\n")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Quotation Sent",
      "field": "quotationSent",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['quotationSent']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'quotationSent', $$v)
            },
            expression: "filters['quotationSent']"
          }
        })]
      },
      proxy: true
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n  " + _vm._s(slotProps.data.quotationSent ? 'Yes' : 'No') + "\n")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Updated Date Np",
      "field": "updateDateNepali",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['updateDateNepali']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'updateDateNepali', $$v)
            },
            expression: "filters['updateDateNepali']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Next Follow Up Date Np",
      "field": "nextFollowUpDateNepali",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['nextFollowUpDateNepali']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'nextFollowUpDateNepali', $$v)
            },
            expression: "filters['nextFollowUpDateNepali']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Enter By",
      "sortable": true,
      "field": "enterBy",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['enterBy']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'enterBy', $$v)
            },
            expression: "filters['enterBy']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Update By",
      "sortable": true,
      "field": "updatedBy",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['updatedBy']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'updatedBy', $$v)
            },
            expression: "filters['updatedBy']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action",
      "headerStyle": "width: 11em"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editCrmFollowUp(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger p-button-sm",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteCrmFollowUp
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  }), _vm._v(" "), _c('remarksDialog', {
    staticClass: "p-fluid",
    style: ({
      width: '500px'
    }),
    attrs: {
      "visible": _vm.dialogVisible,
      "header": _vm.clientName,
      "modal": true
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button p-button-raised p-button-danger",
          attrs: {
            "label": "Close",
            "icon": "pi pi-times"
          },
          on: {
            "click": _vm.closeRemarks
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "productName"
    }
  }, [_vm._v("Products "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "productName",
      "rows": "2",
      "autoResize": ""
    },
    model: {
      value: (_vm.productName),
      callback: function($$v) {
        _vm.productName = $$v
      },
      expression: "productName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "rate"
    }
  }, [_vm._v("Rate "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "rate",
      "rows": "2",
      "autoResize": ""
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "remarks"
    }
  }, [_vm._v("Remarks "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "remarks",
      "rows": "3",
      "autoResize": ""
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "remarks1"
    }
  }, [_vm._v("Remarks 1")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "remarks1",
      "rows": "3",
      "autoResize": ""
    },
    model: {
      value: (_vm.remarks1),
      callback: function($$v) {
        _vm.remarks1 = $$v
      },
      expression: "remarks1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "remarks2"
    }
  }, [_vm._v("Remarks 2")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "remarks2",
      "rows": "3",
      "autoResize": ""
    },
    model: {
      value: (_vm.remarks2),
      callback: function($$v) {
        _vm.remarks2 = $$v
      },
      expression: "remarks2"
    }
  })], 1)])]), _vm._v(" "), _c('remarksDialog', {
    staticClass: "p-fluid",
    style: ({
      width: '500px'
    }),
    attrs: {
      "visible": _vm.productVisible,
      "header": "Products",
      "modal": true
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button p-button-raised p-button-danger",
          attrs: {
            "label": "Close",
            "icon": "pi pi-times"
          },
          on: {
            "click": _vm.closeProductName
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "productName"
    }
  }, [_vm._v("Product Name "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "productName",
      "rows": "3",
      "autoResize": ""
    },
    model: {
      value: (_vm.productName),
      callback: function($$v) {
        _vm.productName = $$v
      },
      expression: "productName"
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2569080e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/crm/crmFollowUpDetails.vue
// module id = 2096
// module chunks = 0